// Pure helpers for the 4-week booking calendar (BookingCalendar). Both the
// pilot Mini App (/book) and the admin dashboard (/admin/:slug) consume
// these so the grid stays consistent across roles.

const RU_MONTHS = [
  "январь","февраль","март","апрель","май","июнь",
  "июль","август","сентябрь","октябрь","ноябрь","декабрь",
];

// "Today" in Europe/Moscow (UTC+3, no DST). The airfield is in MSK; pilots
// flying outside Russia would otherwise see yesterday/tomorrow when their
// device tz is shifted.
export function todayInMskYmd() {
  const now = new Date();
  const mskMs = now.getTime() + 3 * 3600_000;
  const d = new Date(mskMs);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,"0")}-${String(d.getUTCDate()).padStart(2,"0")}`;
}

// Returns `weekCount` rows of 7 YMD strings, starting from the Monday of
// the week containing `anchorYmd`. Days outside the API response still get
// rendered as placeholders so the grid keeps Mon→Sun shape.
export function buildCalendarWeeks(anchorYmd, weekCount = 4) {
  const [y, m, d] = anchorYmd.split("-").map(Number);
  const anchor = Date.UTC(y, m - 1, d);
  // JS getUTCDay: 0=Sun..6=Sat. We want Mon=0..Sun=6.
  const dow = (new Date(anchor).getUTCDay() + 6) % 7;
  const start = anchor - dow * 86400_000;
  const fmt = (ms) => {
    const x = new Date(ms);
    return `${x.getUTCFullYear()}-${String(x.getUTCMonth()+1).padStart(2,"0")}-${String(x.getUTCDate()).padStart(2,"0")}`;
  };
  const weeks = [];
  for (let w = 0; w < weekCount; w++) {
    const row = [];
    for (let i = 0; i < 7; i++) row.push(fmt(start + (w * 7 + i) * 86400_000));
    weeks.push(row);
  }
  return weeks;
}

export function calendarMonthLabel(weeks) {
  const first = weeks[0][0];
  const last = weeks[weeks.length - 1][6];
  const [fy, fm] = first.split("-").map(Number);
  const [ly, lm] = last.split("-").map(Number);
  if (fy === ly && fm === lm) return `${RU_MONTHS[fm-1]} ${fy}`;
  if (fy === ly) return `${RU_MONTHS[fm-1]} – ${RU_MONTHS[lm-1]} ${fy}`;
  return `${RU_MONTHS[fm-1]} ${fy} – ${RU_MONTHS[lm-1]} ${ly}`;
}

// Last day shown in the calendar (Sunday of the final week), used as the
// upper bound for the slots/calendar API request. Caller passes the MSK
// anchor (typically today); we use the grid's actual end so the backend is
// always asked for the days actually rendered.
export function endOfCalendarYmd(anchorYmd, weekCount = 4) {
  const weeks = buildCalendarWeeks(anchorYmd, weekCount);
  return weeks[weekCount - 1][6];
}
